import "./style.scss";

export default function Tag({ label, color, bg, size = "sm" }) {
  return (
    <span
      className="compTag"
      style={{
        "--tag-color": color,
        "--tag-bg": bg || `${color}15`,
        "--tag-padding": size === "md" ? "4px 10px" : "2px 8px",
        "--tag-fs": size === "md" ? "12px" : "11px",
      }}
    >
      {label}
    </span>
  );
}
